<template>
  <form class="person-modal__form">
    <!-- START: Customer Data Section -->
    <div class="row gutter-lg items-start">
      <div class="col-sm-auto col-12 gt-xs">
        <div class="bg-grey-1 circle text-center q-mr-lg" style="height: 125px; width: 125px; line-height: 125px;">
          <q-icon name="person" color="grey-3" size="100px" class="bg-grey-1 circle"/>
        </div>
      </div>

      <div class="col-sm col-12">
        <!-- Salutation -->
        <div class="row gutter-sm">
          <div class="col-sm-6 col-12">
            <salutation-field v-model="formData.salutation" class="full-width"/>
          </div>
        </div>

        <!-- Title -->
        <div class="row gutter-sm">
          <div class="col-sm-6 col-12">
            <q-field :error="errors.has('title')" :error-label="errors.first('title')" class="col-sm-6 col-12">
              <q-input
                v-model="formData.title"
                v-validate.disable="'min:1|max:255'"
                name="title"
                :placeholder="$t('title')"
                required/>
            </q-field>
          </div>
        </div>

        <!-- First and Last Name -->
        <div class="row gutter-x-sm">
          <q-field :error="errors.has('firstName')" :error-label="errors.first('firstName')" class="col-sm-6 col-12">
            <q-input
              ref="firstName"
              v-model="formData.firstName"
              v-validate.disable="'max:255'"
              name="firstName"
              :placeholder="$t('person_first_name')"
              required
            />
          </q-field>

          <q-field :error="errors.has('lastName')" :error-label="errors.first('lastName')" class="col-sm-6 col-12">
            <q-input
              v-model="formData.lastName"
              v-validate.disable="'required|min:1|max:255'"
              name="lastName"
              :placeholder="$t('person_last_name')"
              required
            />
          </q-field>
        </div>

        <div class="row q-mt-md">
          <div class="col-12">
            <multi-email-input
              v-model="formData.emailAddresses"
              hide-label
              show-icon
              label
            />
          </div>
        </div>

        <div class="row q-mt-md">
          <div class="col-12">
            <multi-phone-input
              v-model="formData.phoneNumbers"
              hide-label
              show-icon
              label
            />
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import EmailSubResource from 'src/utils/SubResources/CustomerEmailAddress'
  import MultiEmailInput from 'components/Common/Addressing/MultiEmailInput.vue'
  import MultiPhoneInput from 'components/Common/Addressing/MultiPhoneInput.vue'
  import PhoneSubResource from 'src/utils/SubResources/CustomerPhoneNumber'
  import SalutationField from 'components/Common/SalutationField.vue'

  function initialState (props) {
    return {
      customer_number: '',
      salutation: 'ms',
      title: null,
      firstName: null,
      lastName: '',
      emailAddresses: [
        EmailSubResource.empty()
      ],
      phoneNumbers: [
        PhoneSubResource.empty()
      ]
    }
  }

  export default {
    inject: ['$validator'],

    props: {
      action: {
        required: true,
        type: String
      }
    },

    data () {
      return {
        formData: initialState(this.$props)
      }
    },

    computed: {
      isEditing () {
        return this.action === 'update'
      }
    },

    methods: {
      resetData () {
        this.formData = initialState(this.$props)
      },

      loadData (person) {
        this.formData = Object.assign(initialState(this.$props), person)
      },

      focus () {
        this.$refs.firstName.focus()
      }
    },

    watch: {
      formData: {
        handler: function (newVal) {
          let data = Object.assign({}, newVal)

          if (data.firstName === '') {
            data.firstName = null
          }

          this.$emit('input', data)
        },
        deep: true
      }
    },

    components: {
      SalutationField,
      MultiEmailInput,
      MultiPhoneInput
    }
  }
</script>
